export default __webpack_public_path__ + "gap-icon690a84.png";